import { Button, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from 'react-router-dom';

import type { IAnnouncementUpdate } from '../types';
import type { AnnouncementLoaderType } from '../queries';

import { useAnnouncementQuery, useAnnouncementUpdate } from '../queries';
import { useValidation } from '@/hooks/useValidation';
import { routes } from '@/app/router/routes';

import { FormCommon } from './FormCommon';
import { PageHeader } from '@/ui/PageHeader';
import { Loading } from '@/ui/Loading';

export const AnnouncementUpdate = (): JSX.Element => {
  const { t } = useTranslation();
  const [form] = Form.useForm<IAnnouncementUpdate>();
  const { validate } = useValidation();
  const initialData = useLoaderData() as AnnouncementLoaderType;
  const { data: announcement, isLoading: isLoadingQuery } = useAnnouncementQuery(initialData);
  const { mutate: announcementUpdate, isLoading: isLoadingMutation } = useAnnouncementUpdate();

  const submitHandler = (data: IAnnouncementUpdate) => {
    announcementUpdate(data);
  };

  return (
    <>
      <PageHeader
        title={t('announcements.form.updateTitle')}
        description={t('announcements.form.updateDescription')}
        navigateBackUrl={routes.announcements()}
      />
      <Loading loading={isLoadingQuery}>
        <Form
          name='announcementUpdate'
          form={form}
          initialValues={{ ...announcement, photo: announcement.photo.id }}
          requiredMark='optional'
          layout='vertical'
          onFinish={submitHandler}
          scrollToFirstError
        >
          <Form.Item name='id' rules={validate('required')} hidden>
            <Input />
          </Form.Item>

          <FormCommon initialPhotoUrl={announcement.photo.path} />

          <Form.Item>
            <Button type='primary' htmlType='submit' loading={isLoadingMutation}>
              {t('global.save')}
            </Button>
          </Form.Item>
        </Form>
      </Loading>
    </>
  );
};
